import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { SignatureSection } from '../../../../components/generic'
import { onSubmit } from './utils'

const Signatures = (props) => {
  const {
    resident,
    carePlan,
    logs,
    setLoadedListItem,
    preferredCarePlanName,
    item,
    category,
  } = props

  const [isSubmitting, setIsSubmitting] = useState(false)
  if (!resident || !carePlan) return null

  const carePlanName = `${carePlan.customName || carePlan.carePlanAdl.name}`
  const handleSubmit = ({ formState, onSuccess }) => {
    if (isSubmitting) return
    setIsSubmitting(true)
    onSubmit({
      formState,
      carePlan,
      resident,
      onSuccess: () => {
        onSuccess() // modal callback to reset modal state
        setIsSubmitting(false)
      },
      onError: () => {
        setIsSubmitting(false)
      },
      setLoadedListItem,
      preferredCarePlanName,
      carePlanName,
      item,
      category,
    })
  }

  return (
    <SignatureSection
      title="Signatures"
      buttonLabel={`Sign ${preferredCarePlanName}`}
      footerLabel={carePlanName}
      confirmText={`I confirm that I have been fully informed of, and understand, the ${preferredCarePlanName}`}
      resident={resident}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      logs={logs}
      helpUrl="https://support.logmycare.co.uk/en/articles/5685192-how-do-i-sign-a-care-plan"
    />
  )
}

Signatures.propTypes = {
  resident: PropTypes.object,
  carePlan: PropTypes.object,
  logs: PropTypes.array,
  setLoadedListItem: PropTypes.func,
  preferredCarePlanName: PropTypes.string,
  item: PropTypes.string,
  category: PropTypes.string,
}

export default Signatures
